import Vue from 'vue/dist/vue.esm.js'
KCVS.Views.UserReportRowsIndexView = Vue.extend(
  data: ->
    currentView: 'invoice-rows'
  components:
    'invoice-rows': KCVS.Views.UserReportInvoiceRowsTable
    'agreement-rows': KCVS.Views.UserReportAgreementRowTable
    'involved-employee-rows': KCVS.Views.UserReportInvolvedEmployeeRowTable

  methods:
    switchView: (view) ->
      @currentView = view
)
